export const translations = {
  'language': {
    en: 'Language',
    sw: 'Lugha'
  },
  'nav.menu': {
    en: 'Menu',
    sw: 'Menyu'
  },
  'nav.home': {
    en: 'HOME',
    sw: 'NYUMBANI'
  },
  'nav.about': {
    en: 'ABOUT US',
    sw: 'KUHUSU SISI'
  },
  'nav.publications': {
    en: 'PUBLICATIONS',
    sw: 'MACHAPISHO'
  },
  'nav.resources': {
    en: 'RESOURCES',
    sw: 'RASILIMALI'
  },
  'nav.news': {
    en: 'NEWS',
    sw: 'HABARI'
  },
  'nav.events': {
    en: 'EVENTS',
    sw: 'MATUKIO'
  },
  'nav.gallery': {
    en: 'GALLERY',
    sw: 'PICHA'
  },
  'nav.contact': {
    en: 'CONTACT',
    sw: 'WASILIANA'
  },
  'nav.faqs': {
    en: 'FAQS',
    sw: 'MASWALI'
  },
  'welcome.title': {
    en: 'Welcome to the High Court of Tanzania',
    sw: 'Karibu Mahakama Kuu ya Tanzania'
  },
  'welcome.description': {
    en: 'Welcome to Acts of Kindness Association! Thank you for stopping by! We\'re a nonprofit agency dedicated to delivering quality service to our local residents.',
    sw: 'Karibu kwenye Chama cha Matendo ya Ukarimu! Asante kwa kupitia! Sisi ni shirika lisilo la faida linalojitoa kutoa huduma bora kwa wakazi wetu.'
  },
  'welcome.readMore': {
    en: 'Read More',
    sw: 'Soma Zaidi'
  },
  'notice.title': {
    en: 'Notice Board',
    sw: 'Ubao wa Matangazo'
  },
  'downloads.title': {
    en: 'Downloads',
    sw: 'Vipakuliwa'
  },
  'news.title': {
    en: 'Latest News',
    sw: 'Habari Mpya'
  },
  'events.title': {
    en: 'Latest Events',
    sw: 'Matukio Mapya'
  },
  'footer.contact': {
    en: 'Contact Us',
    sw: 'Wasiliana Nasi'
  },
  'footer.submit': {
    en: 'Submit',
    sw: 'Tuma'
  },
  'footer.copyright': {
    en: 'Copyright © {year} All Rights Reserved',
    sw: 'Haki Zote Zimehifadhiwa © {year}'
  }
};